module.exports = __webpack_public_path__ + "static/media/startups.b2082614.svg";